import { render, staticRenderFns } from "./Salespage.vue?vue&type=template&id=18e2bd01"
import script from "./Salespage.vue?vue&type=script&lang=js"
export * from "./Salespage.vue?vue&type=script&lang=js"
import style0 from "./Salespage.vue?vue&type=style&index=0&id=18e2bd01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports